<!--
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-09-24 10:22:29
 * @LastEditors: FJW
 * @LastEditTime: 2024-11-15 16:40:21
-->
<template>
  <div class="box">
    <el-tabs>
      <el-tab-pane label="商品列表">
        <ShopList @sendRichTextMessage="sendRichTextMessage"></ShopList>
      </el-tab-pane>
      <el-tab-pane label="用户订单">
        <OrderList @sendRichTextOrder="sendRichTextOrder" ref="orderRef"></OrderList>
      </el-tab-pane>
      <el-tab-pane label="用户足迹">
        <History @sendRichTextMessage="sendRichTextMessage" ref="historyRef"></History>
      </el-tab-pane>
      <el-tab-pane label="客服转接">
        <Customer ref="customerRef"></Customer>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
    
<script>
import ShopList from './common/ShopList.vue'
import OrderList from './common/OrderList.vue'
import History from './common/History.vue'
import Customer from './common/Customer.vue'
export default {
  components: { ShopList, OrderList, History, Customer },
  methods: {
    // 发送富文本
    sendRichTextMessage(item) {
      this.$emit('sendRichTextMessage', item)
    },

    // 发送订单
    sendRichTextOrder(item) {
      this.$emit('sendRichTextOrder', item)
    }
  }
}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.box {
  box-sizing: border-box;
  padding: 20px;
  padding-bottom: 0;
  min-width: 500px;
}
</style>